/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  CssBaseline,
  Grid,
  makeStyles,
  Card,
  Typography,
  CardContent,
  FormControl,
  FormLabel,
  Button,
  Select,
} from "@material-ui/core";

//import InformeComercial from '/static/imagen/InformeComercialPlus1.png';
import "date-fns";
import DateMomentUtils from "@date-io/moment"; // esta hace que se convierta en español

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import Fade from "@material-ui/core/Fade";

import UserContext from "../../context/Globales/UserContext";
import Loading from "../modales/Loading";

import DataTableRegistroConsulta from "./DataTableRegistroConsulta";
import { globales } from "../../helpers/Confi";
import { DecodificanString } from "../../helpers/Codifican";
import Alert from "@material-ui/lab/Alert";
import BarraProgress from "../modales/BarraProgress";
import { isMobile } from "react-device-detect";

const useStyle = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(1, 4),
    textAlign: "center",
  },
  titulo: {
    margin: theme.spacing(4, 2),
    textAlign: "center",
  },
  submit: {
    width: "60%",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));

const RegistroConsultaTest = () => {
  const history = useHistory();
  const classes = useStyle();
  const parametros = globales(); //  parametros globales:

  const [StateMensaje, setStateMensaje] = useState();

  const [verGrafico, setVerGrafico] = useState(false);

  const [OpenLoading, setOpenLoading] = useState(false);

  const [error, setError] = useState(false);

  const [open, setOpen] = useState(false);

  const userContext = useContext(UserContext);

  const [fechaDesde, setFechaDesde] = useState(new Date());
  const [fechaHasta, setFechaHasta] = useState(new Date());
  const [dataFecha, setDataFecha] = useState({
    fecha1: "",
    fecha2: "",
  });

  //  console.log(FechaActual);

  //info de la api de bancos
  const { DataUsuarios, DataResumen } = useContext(UserContext);

  ////console.log(DataUsuarios);

  const [busquedaConsulta, guardarBusquedaConsulta] = useState({
    usuario: "",
  });

  const { usuario } = busquedaConsulta;

  localStorage.setItem("usuarioConsultado", JSON.stringify(usuario));

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChange = (e) => {
    guardarBusquedaConsulta({
      ...busquedaConsulta,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (date) => {
    setFechaDesde(date);
  };

  const handleDateFinalChange = (date) => {
    setFechaHasta(date);
  };

  useEffect(() => {
    userContext.getUsuarios(); // que se ejecute la primera vez
  }, []);

  const handleSubmit = () => {
    setOpenLoading(true);

    if (fechaHasta < fechaDesde) {
      setStateMensaje(
        'La Fecha dos es menor a la fecha uno "Validar e intente de nuevo" '
      );
      setOpenLoading(false);
      return;
    } else if (fechaDesde > fechaHasta) {
      setStateMensaje(
        'La Fecha dos es menor a la fecha uno "Validar e intente de nuevo" '
      );
      setOpenLoading(false);
      return;
    } else if (usuario === 0) {
      setStateMensaje(
        'No has seleccionado un usuario correcto "Validar e intente de nuevo" '
      );
      setOpenLoading(false);
      return;
    } else {
      if (
        JSON.parse(localStorage.getItem("jwt")) &&
        DecodificanString(JSON.parse(localStorage.getItem("autenticado")))
      ) {
        userContext.getResumenConsultas(
          busquedaConsulta,
          fechaDesde,
          fechaHasta
        );
        setDataFecha({
          fecha1: fechaDesde,
          fecha2: fechaHasta,
        });
        setTimeout(() => {
          setError(false);

          handleOpen();
          setOpenLoading(false);
        }, 9000);
      } else {
        setError(true);
        setOpenLoading(false);
      }
    }
  };
  const OcultarMensaje = () => {
    setStateMensaje(false);
  };
  //console.log(usuario)
  const AlertError = (
    <>
      <Alert
        variant="filled"
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={OcultarMensaje}>
            ACEPTAR
          </Button>
        }
      >
        {StateMensaje}
      </Alert>
    </>
  );

  return (
    <div>
      <CssBaseline />
      <br />
      {/*OpenLoading ? <Loading /> : null */}

      <br />

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={4} xl={5} lg={5}>
          <Card className={classes.root}>
            <CardContent>
              {isMobile ? (
                <>
                  <br />
                  <br />
                  <br />
                  <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => history.push("MenuMobile")}
                      style={{ alignItems: "center", paddingTop: "5px" }}
                    >
                      Menú Principal
                    </Button>
                  </Grid>
                </>
              ) : (
                ""
              )}

              <Typography
                component="h1"
                variant="h4"
                className={classes.titulo}
              >
                <img
                  src={process.env.PUBLIC_URL + "/static/imagen/VCderiesgo.png"}
                  style={{ width: "100px", height: "100px" }}
                  alt="logo vc riesgo"
                  title="logo vc riesgo"
                />
                <br />
                Registro Consultas
              </Typography>
              {StateMensaje ? AlertError : ""}

              <Grid
                container
                spacing={3}
                xs={12}
                sm={12}
                md={12}
                xl={12}
                lg={12}
                justify="space-between"
                alignItems="center"
              >
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  {/* llenado de combobox con la api*/}
                  <FormLabel style={{ textAlign: "left" }}>
                    Lista Usuarios
                  </FormLabel>
                  <FormControl variant="outlined" fullWidth margin="normal">
                    <Select
                      native
                      name="usuario"
                      value={usuario}
                      onChange={handleChange}
                    >
                      <option value="">Todos los usuarios </option>
                      {DataUsuarios.map((item) => (
                        <>
                          <option key={item} value={item}>
                            {" "}
                            {item}{" "}
                          </option>
                        </>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <FormControl fullWidth margin="normal" size="small">
                    <FormLabel style={{ textAlign: "left" }}> Desde </FormLabel>
                    <MuiPickersUtilsProvider utils={DateMomentUtils}>
                      <KeyboardDatePicker
                        clearable
                        value={fechaDesde}
                        name="fechaDesde"
                        disableFuture={true}
                        placeholder="10/10/2018"
                        onChange={handleDateChange}
                        //minDate={new Date()}
                        format="DD/MM/YYYY"
                        variant="inline"
                        inputVariant="outlined"
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <FormControl fullWidth margin="normal" size="small">
                    <FormLabel style={{ textAlign: "left" }}> Hasta </FormLabel>
                    <MuiPickersUtilsProvider utils={DateMomentUtils}>
                      <KeyboardDatePicker
                        //clearable
                        value={fechaHasta}
                        name="fechaHasta"
                        placeholder="10/10/2018"
                        onChange={handleDateFinalChange}
                        //maxDate={new Date()}
                        minDate={new Date()}
                        format="DD/MM/YYYY"
                        variant="inline"
                        inputVariant="outlined"
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  {!OpenLoading ? (
                    <Button
                      color="secondary"
                      disabled={fechaDesde && fechaHasta ? false : true}
                      size="large"
                      type="submit"
                      variant="contained"
                      onClick={handleSubmit}
                      className={classes.submit}
                    >
                      Consultar Reporte
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      disabled={true}
                      size="large"
                      type="submit"
                      variant="contained"
                      onClick={handleSubmit}
                      className={classes.submit}
                    >
                      Cargando información...
                    </Button>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={12} md={8} xl={7} lg={7}>
          {DataResumen ? (
            <Fade in={open}>
              <Grid
                xs={12}
                sm={12}
                md={12}
                xl={12}
                lg={12}
                direction="column"
                justify="center"
                alignItems="center"
                elevation={3}
                className={classes.root}
              >
                <Grid item xs={12} sm={12} md={12} xl={12}>
                  {/*<ConsultaApiRegistroConsulta/> */}
                  <DataTableRegistroConsulta dataFecha={dataFecha} />
                  {/*aqui ira la vista con la informacion desde la api de la tabla*/}
                </Grid>
              </Grid>
            </Fade>
          ) : (
            ""
          )}
          {!DataResumen && OpenLoading
            ? "Estamos procesando la información solicitada...."
            : ""}
          {!DataResumen && OpenLoading ? <BarraProgress /> : ""}
        </Grid>
      </Grid>
    </div>
  );
};

export default RegistroConsultaTest;
